module.exports = __webpack_public_path__ + "img/xuanzhong_n.327f82a5.svg";